import React, { useEffect, useState } from "react";

const CustomPaginationTable = ({ data, setCurrentData, className, action }) => {
    const [preData, setPreData] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const visiblePages = 5;

    const totalPages = Math.ceil(data.length / pageSize);

    // --- Slice Data for Current Page ---
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const currentData = data.slice(startIndex, endIndex);

    // --- Sliding Pagination Window ---
    const block = Math.floor((currentPage - 1) / visiblePages);
    const startPage = block * visiblePages + 1;
    const endPage = Math.min(startPage + visiblePages - 1, totalPages);
    const pageNumbers = Array.from(
        { length: endPage - startPage + 1 },
        (_, i) => startPage + i
    );

    const goToPage = (page) => {
        if (page >= 1 && page <= totalPages) setCurrentPage(page);
    };

    useEffect(() => {
        function isArrayObjectsEqual(arr1, arr2) {
            // arr2 empty ho sakta hai, isliye length check skip
            return arr1.every((obj, index) => {
                const other = arr2[index] || {};
                return Object.keys(obj).every(key => obj[key] === other[key]);
            });
        }

        if (isArrayObjectsEqual(currentData, preData) === false) {
            setPreData(data.length === 0 ? [] : currentData)
            setCurrentData(data.length === 0 ? [] : currentData)
        }
    }, [currentData])



    return (
        <div className={className}>
            {/* Table */}
            {/* Pagination Controls */}
            <div
                className="d-flex align-items-center gap-2"
            >
                <button onClick={() => goToPage(currentPage - 1)} disabled={currentPage === 1}>
                    &lt;
                </button>

                {pageNumbers.map((page) => (
                    <button
                        key={page}
                        onClick={() => goToPage(page)}
                        className={page === currentPage ? "active" : ""}
                    // style={{
                    //     fontWeight: page === currentPage ? "bold" : "normal",
                    //     background: page === currentPage ? "#007bff" : "white",
                    //     color: page === currentPage ? "white" : "black",
                    //     border: "1px solid #ccc",
                    //     borderRadius: 4,
                    //     padding: "4px 10px",
                    //     cursor: "pointer",
                    // }}
                    >
                        {page}
                    </button>
                ))}

                <button
                    disabled={currentPage === totalPages}
                    onClick={() => goToPage(currentPage + 1)}
                >
                    &gt;
                </button>

                {/* Page Size Selector */}
                <div className="d-flex align-items-center gap-2">
                    <select
                        value={pageSize}
                        onChange={(e) => {
                            setPageSize(Number(e.target.value));
                            setCurrentPage(1);
                        }}
                        style={{ marginLeft: 12, width: "100px" }}
                        className="form-select color-white"
                        id="pageSizeSelect"
                    >
                        {[10, 20, 50, 100].map((size) => (
                            <option key={size} value={size}>
                                {size}
                            </option>
                        ))}
                    </select>
                </div>
            </div>

            {action}
        </div>
    );
};

export default CustomPaginationTable;
